<template>
  <transition-group name="flip-list" tag="ul">
    <li class="mb-2" v-for="(item, index) in workingList" :key="'_' + item.adminname">
      <v-card style="position: relative" @click="$emit('onSelectAdmin', item)">
        <div
          class="text-xs-center"
          style="position: absolute; top: -25px;z-index: 1; left: 0; right: 0"
        >
          <img src="/static/img/assets/aston/crowns.png" v-if="index == 0" style="width: 30px; " />
        </div>

        <v-card-text>
          <div class="text-xs-center">
            <v-avatar size="50">
              <img :src="item.image_url" />
            </v-avatar>
            <div class="mt-2 font-weight-bold">
              {{ item.adminname ? item.adminname : '-' }}
            </div>
            <v-divider class="mt-1 mb-2"></v-divider>

            <v-layout wrap>
              <v-flex xs6 style="border-right: 1px solid #eee">
                <div class="caption">จำนวนทำงาน</div>
                <h2 class=" primary--text display-1 font-weight-bold">
                  {{ item.closetask | numberFormat }}
                </h2>
              </v-flex>
              <v-flex xs6>
                <div class="caption">เวลาในการทำต่องาน</div>
                <h2 class=" primary--text display-1 font-weight-bold">
                  <span v-html="dayLeft(item.timePerTask)"></span>
                </h2>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </li>
  </transition-group>
</template>

<script>
import api from '@/api'
import dayjs from 'dayjs'

import duration from 'dayjs/plugin/duration'


export default {
  props: ['datefrom', 'dateto', 'outsource', 'datevalue'],
  data: function() {
    return {
      workingList: [],
      refreshInterval: undefined
    }
  },
  mounted: function() {
    var vm = this
    dayjs.extend(duration)
    vm.getAdmin()
    if (
      // only reset for today
      (vm.datefrom == dayjs().format('YYYY-MM-DD'), vm.dateto == dayjs().format('YYYY-MM-DD'))
    ) {
      vm.refreshInterval = setInterval(function() {
        vm.getAdmin()
      }, 15000)
    }
  },
  methods: {
    dayLeft: function(second) {
      var duration = dayjs.duration(parseInt(second), 'seconds')
      var time = ''
      // if (duration.days() > 0) {
      //   time = duration.days()
      //   time += ' <div class="headline font-weight-bold">' + this.$t('Days') + '</div>'
      // } else if (duration.hours() > 0) {
      //   time = duration.hours()
      //   time += ' <div class="headline font-weight-bold">' + this.$t('Hours') + '</div>'
      // } else
      if (duration.minutes() > 0) {
        // time = duration.minutes() || 0
        time = Math.round(second / 60).toLocaleString()
        time += ' <div class="font-weight-bold">' + this.$t('Minutes') + '</div>'
      } else {
        // time = duration.seconds() || 0
        time = Math.round(second).toLocaleString()
        time += ' <div class="font-weight-bold">' + this.$t('Seconds') + '</div>'
      }
      return time
    },
    playCheerSound: function() {
      var snd = new Audio('/static/sound/cheer.wav')
      snd.play()
    },
    getAdmin: function() {
      var vm = this
      vm.getAstonCloseTasksPerAdmin().then(function(workingList) {
        var firstPlace = null
        if (vm.workingList && vm.workingList.length > 0) {
          firstPlace = vm.workingList[0].adminname
        }

        vm.workingList = workingList.map(el => {
          return {
            ...el,
            timePerTask:
              parseInt(el.closetask) > 0 ? (el.timereply / parseInt(el.closetask)).toFixed(0) : 0
          }
        })

        var average =
          vm.workingList.reduce((prev, current) => {
            return prev + parseFloat(current.timePerTask)
          }, 0) / vm.workingList.length

        vm.$emit('getAverage', average)

        if (workingList.length > 0) {
          if (firstPlace != null && firstPlace != workingList[0].adminname) {
            vm.playCheerSound()
          }
        }
      })
    },
    getAstonCloseTasksPerAdmin: function() {
      let vm = this
      var data = {
        datefrom: dayjs(vm.datefrom).format('YYYY/MM/DD'),
        dateto: dayjs(vm.dateto).format('YYYY/MM/DD')
      }
      let apifunc = vm.outsource
        ? 'getAstonCloseTasksPerAdminOutsource'
        : 'getAstonCloseTasksPerAdmin'
      return new Promise((resolve, reject) => {
        api[apifunc](data, function(error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          if (response.data) {
            resolve(response.data)
          }
          resolve([])
        })
      })
    }
  },
  beforeDestroy: function() {
    clearInterval(this.refreshInterval)
  },
  watch: {
    datevalue(value, oldVal) {
      clearInterval(this.refreshInterval)
      var vm = this
      vm.datevalue = value
      vm.getAdmin()
      if (value == 'today') {
        if (
          // only reset for today
          (vm.datefrom == dayjs().format('YYYY-MM-DD'), vm.dateto == dayjs().format('YYYY-MM-DD'))
        ) {
          vm.refreshInterval = setInterval(function() {
            vm.getAdmin()
          }, 10000)
        }
      }
    },
    datefrom(value, oldVal) {
      if (!this.datevalue) {
        this.getAdmin()
      }
    },
    dateto(value, oldVal) {
      if (!this.datevalue) {
        this.getAdmin()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/AstonAdminList.vue